import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import styles from "../../_css/CollapsibleSection.module.css";

const CollapsibleSection = ({
  title,
  children,
  defaultOpen = false,
  className = "",
  headerClassName = "",
  open, // new
  onHeaderClick, // new
}) => {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const isOpen = open !== undefined ? open : internalOpen;

  const handleHeaderClick = () => {
    if (onHeaderClick) {
      onHeaderClick();
    } else {
      setInternalOpen((o) => !o);
    }
  };

  return (
    <div style={{ marginBottom: "12px" }} className={className}>
      <div
        className={headerClassName}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          fontWeight: 600,
          color: "#102554",
          fontSize: "17px",
          padding: "12px 24px",
        }}
        onClick={handleHeaderClick}
      >
        <span>{title}</span>
        {isOpen ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
      </div>
      <div
        className={
          isOpen
            ? `${styles.collapsibleContent} ${styles.collapsibleContentOpen}`
            : styles.collapsibleContent
        }
        style={{ marginTop: "0" }}
      >
        {children}
      </div>
    </div>
  );
};

export default CollapsibleSection; 